import { useEffect, useRef, useState } from "react";
import { NotificationManager } from "react-notifications";
import { BitacoraFletesApi } from "../api/BitacoraFletesApi";
import { getErrorFromResponse } from "../../../../../../utility/utils";

/**
 * Consulta los datos de la finca y su historial de cambios de flete.
 * @param {*} fincaId - Finca seleccionada en el listado
 */
export const useBitacoraFletes = (fincaId) => {
    const { getRegistros, getDatosFinca, cargando } = BitacoraFletesApi();

    const [finca, setFinca] = useState(null);
    const [registros, setRegistros] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    // Vacío muestra los fletes ajenos y propios
    const [ambitoFlete, setAmbitoFlete] = useState("");

    // Evita que una consulta lenta sobrescriba el resultado de la más reciente
    const ultimaConsulta = useRef(0);

    const obtenerDatosFinca = async () => {
        try {
            const response = await getDatosFinca({ finca_id: fincaId });
            setFinca(response);
        } catch (error) {
            const mensaje = getErrorFromResponse(
                error,
                "No se pudieron obtener los datos de la finca",
            );
            NotificationManager.error(mensaje, "ERROR", 5000);
            setFinca(null);
        }
    };

    const obtenerRegistros = async () => {
        const consulta = ultimaConsulta.current + 1;
        ultimaConsulta.current = consulta;

        try {
            const response = await getRegistros({
                finca_id: fincaId,
                ambito_flete: ambitoFlete,
                page: paginaSeleccionada,
            });

            if (consulta !== ultimaConsulta.current) return;

            setRegistros(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            if (consulta !== ultimaConsulta.current) return;

            // Si la página ya no existe se regresa a la anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada(paginaSeleccionada - 1);
                return;
            }

            const mensaje = getErrorFromResponse(
                error,
                "No se pudo obtener la bitácora de fletes",
            );
            NotificationManager.error(mensaje, "ERROR", 5000);
            setRegistros([]);
            setCantidadResultados(0);
        }
    };

    // El listado filtrado se consulta desde la primera página
    const cambiarAmbitoFlete = (valor) => {
        setAmbitoFlete(valor);
        setPaginaSeleccionada(1);
    };

    useEffect(() => {
        obtenerDatosFinca();
    }, [fincaId]);

    useEffect(() => {
        obtenerRegistros();
    }, [fincaId, ambitoFlete, paginaSeleccionada]);

    return {
        finca,
        registros,
        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,
        ambitoFlete,
        cambiarAmbitoFlete,
        cargando,
    };
};
